import React, { useRef,useState } from 'react';
import {Mail,Phone,LockKeyhole,ArrowLeft,Check} from 'lucide-react';
import { useCareerLanguage } from './CareerLanguage';
import {AuthShell,AuthField,AuthSubmit,AuthMessage,authValidation,focusAuthError} from './CareerAuth';
import {resetPhone,passwordResetError} from './passwordReset';
export default function CareerForgot({
  onClose,onBack=onClose
}) {
  const {
    t
  } = useCareerLanguage();
  const [step, setStep] = useState(0),
    [email, setEmail] = useState(''),
    [phone, setPhone] = useState(''),
    [channel, setChannel] = useState('email'),
    [code, setCode] = useState(''),
    [password, setPassword] = useState(''),
    [confirm, setConfirm] = useState(''),
    [busy, setBusy] = useState(false),
    [error, setError] = useState(''),
    [done, setDone] = useState(false),[fieldErrors,setFieldErrors]=useState({});
  const busyRef=useRef(false);
  async function submit(e) {
    e.preventDefault();
    if (busyRef.current) return;
    const issues=authValidation({email,phone,code,password,confirm},[channel==='phone'?['phone']:['email'],['code'],['password','confirm']][step],t);
    if(step===0&&channel==='phone'&&phone.trim()&&!resetPhone(phone))issues.phone=t('resetInvalidPhone');
    if(issues.code)issues.code=t('resetInvalidCode');
    setFieldErrors(issues);if(Object.keys(issues).length){focusAuthError(issues,'ca-reset-');return;}
    busyRef.current=true;
    setBusy(true);
    setError('');
    try {
      const route = ['forgotpassword', 'verify-reset-code', 'resetpassword'][step];
      const body = {
        identifier: channel==='phone'?resetPhone(phone):email.trim(),
        channel,
        ...(step>0?{code}:{}),
        ...(step===2?{newPassword:password,newPasswordConfirm:confirm}:{})
      };
      const r = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/Auth/${route}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(body)
      });
      if (!r.ok){setError(await passwordResetError(r,t));return;}
      if (step < 2) setStep(step + 1);else {
        setDone(true);
        setPassword('');
        setConfirm('');
      }
    } catch {
      setError(t('authNetworkError'));
    } finally {
      busyRef.current=false;
      setBusy(false);
    }
  }
  const clear=()=>{setFieldErrors({});setError('');};
  const changeChannel=value=>{if(busyRef.current)return;setChannel(value);setCode('');setPassword('');setConfirm('');clear();};
  return <AuthShell title={t('forgot')} intro={done?undefined:t(['resetIntro',channel==='phone'?'resetSmsSent':'authVerifyIntro','authResetIntro'][step])} busy={busy} onClose={onClose} focusKey={String(step)+done+channel}>
   {done?<div className="ca-success" role="status"><span className="ca-success-icon"><Check size={28}/></span><p>{t('authResetDone')}</p><button type="button" className="ca-submit" onClick={onBack}>{t('login')}</button></div>:<>
    {step===0&&<div className="ca-mode-switch" role="group" aria-label={t('forgot')}><button type="button" aria-pressed={channel==='email'} disabled={busy} onClick={()=>changeChannel('email')}>{t('email')}</button><button type="button" aria-pressed={channel==='phone'} disabled={busy} onClick={()=>changeChannel('phone')}>{t('resetPhoneChannel')}</button></div>}
    {step===1&&<div className="ca-mail-address">{channel==='phone'?<Phone size={18}/>:<Mail size={18}/>}<span>{channel==='phone'?'+90 '+resetPhone(phone):email.trim()}</span></div>}
    <form className="ca-form" onSubmit={submit} noValidate aria-busy={busy}>
     <fieldset className="ca-form-fields" disabled={busy}>
     {step===0?(channel==='phone'?<AuthField id="ca-reset-phone" label={t('phone')} icon={Phone} type="tel" required autoComplete="tel" inputMode="tel" maxLength={32} placeholder="05xx xxx xx xx" hint={t('resetPhoneHint')} value={phone} error={fieldErrors.phone} data-auth-autofocus onChange={e=>{setPhone(e.target.value);clear();}}/>:<AuthField id="ca-reset-email" label={t('email')} icon={Mail} type="email" required autoComplete="email" maxLength={256} placeholder="name@example.com" value={email} error={fieldErrors.email} data-auth-autofocus onChange={e=>{setEmail(e.target.value);clear();}}/>):step===1?<AuthField id="ca-reset-code" label={t('code')} required className="ca-code-field" autoComplete="one-time-code" inputMode="numeric" maxLength={6} placeholder="000000" value={code} error={fieldErrors.code} data-auth-autofocus onChange={e=>{setCode(e.target.value.replace(/\D/g,'').slice(0,6));clear();}}/>:<>
      <AuthField id="ca-reset-password" label={t('password')} icon={LockKeyhole} password required autoComplete="new-password" minLength={6} maxLength={128} value={password} hint={t('passwordNote')} error={fieldErrors.password} data-auth-autofocus onChange={e=>{setPassword(e.target.value);clear();}}/>
      <AuthField id="ca-reset-confirm" label={t('authConfirmPassword')} icon={LockKeyhole} password required autoComplete="new-password" minLength={6} maxLength={128} value={confirm} error={fieldErrors.confirm} onChange={e=>{setConfirm(e.target.value);clear();}}/>
     </>}
     </fieldset><AuthMessage error={error}/><AuthSubmit busy={busy} label={t(['sendCode','verify','save'][step])}/>
    </form>
    <footer className="ca-footer">{step>0&&<button type="button" className="ca-link" disabled={busy} onClick={()=>{setStep(x=>x-1);if(step===1)setCode('');setPassword('');setConfirm('');clear();}}><ArrowLeft size={14}/>{t('back')}</button>}<button type="button" className="ca-link" disabled={busy} onClick={onBack}>{t('authBackLogin')}</button></footer>
   </>}
  </AuthShell>;
}
